import { useMutation, useQueryClient } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { API_PATIENT_NOTE_CREATE } from 'services/dataService/ccmResources';
import { showResult } from 'infrastructure/hooks/utils';
import { isApcmModule, isRpmModule } from 'infrastructure/functions';

import { getClinicalNotesKey } from './use-get-clinical-notes';

import type {
  IAddClinicNotes,
  IAddClinicNotesResponse,
} from 'infrastructure/interfaces';

export const addClinicalNotesFn = async (postData: IAddClinicNotes) => {
  let url = API_PATIENT_NOTE_CREATE;

  if (isRpmModule(postData.module) || isApcmModule(postData.module))
    url = `core/patient/clinical-notes`;

  const { data, error } = await dataService.createOne<IAddClinicNotesResponse>(
    url,
    postData,
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};

export const useAddClinicalNotes = () => {
  const queryClient = useQueryClient();

  const {
    mutate: addClinicalNotes,
    mutateAsync: addClinicalNotesAsync,
    isLoading,
    ...other
  } = useMutation({
    mutationFn: addClinicalNotesFn,
    onSuccess(data, variables) {
      const queryKey = getClinicalNotesKey({
        patientGuid: variables.patientGuid,
        module: variables.module,
      });
      queryClient.invalidateQueries(queryKey);
      showResult();
    },
  });

  return {
    addClinicalNotes,
    addClinicalNotesAsync,
    addLoading: isLoading,
    ...other,
  };
};
